<template lang="html">
  <div class="container-fluid">
    <div class="container-fluid">
<table class="table table-hover table-sm col-md-11" ref="transtable" :data="trans">

  <thead>
    <div class = "row" slot="header">
      <h3 scope="col">
       Transactions 
      </h3>
    </div>
    <tr>
      <th class="text-center" scope="col">Description</th>
      <th class="text-center" scope="col">Amount</th>
      <th class="text-center" scope="col">Date</th>
      <th class="text-center" scope="col"></th>
    </tr>
  </thead>
  <tbody>
        <tr v-for="(tran, index) in trans" v-bind:key="index" >
          <td class="text-center" scope="row">
            {{tran.desc}}
          </td>
          <td class="text-center">
            {{tran.amount}}
          </td>
            <td class="text-center">
            {{tran.date}}
          </td>
        </tr>
  </tbody>
  </table>
  </div>

<div class="form-group col-md-3">
        <button type="button" class="btn btn-primary" @click="loadtransactions">Load Transactions</button>
        </div>
  
</div>
  </div>

</template>

<script>
import db from './firebaseInit'
import firebase from 'firebase/app'
import axios from 'axios'
require('@firebase/auth');
require('@firebase/database');
require('@firebase/firestore');
require('@firebase/functions');
require('@firebase/messaging');
require('@firebase/storage');
require('@firebase/performance');

export default {
  name: 'trans',
  data () {
    return {
      goals: [],
      trans: [],
      desc : null,
      amount : null,
      gdate: null,
      userid: null
    }
  },
created: function(){
    
    var user = firebase.auth().currentUser;
   if (user != null) {
      this.userid = user.uid;
      } 

  },
mounted (){  
    var userId
  var user = firebase.auth().currentUser;
   if (user != null) {
      userId = user.uid;
      } 
  db.collection('users').doc(userId).collection('transactions').orderBy('date', 'desc').get().then
  (querySnapshot => {
    querySnapshot.forEach(doc => {
      //console.log(doc.data());
      const data = {
        'id' : doc.id,
        'desc' : doc.data().name,
        'amount' : '$' + parseFloat(doc.data().amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'),
        'date' : doc.data().date
      }
      this.trans.push(data)
      //console.log(data)
    })
  }
  )
  },
  methods: {

loadtransactions: function(){
  var userId = this.userid
 
   db.collection('users').doc(userId).collection('plaid').doc('auth').get().then
  (snap => {
    const data = {'access_token' : snap.data().access_token} 
 
axios.get('/api/v1/transactions/', data).then(transdata => {
  transdata.data.transactions.transactions.forEach(tran => {
    db.collection('users').doc(userId).collection('transactions').doc(tran.transaction_id).set(tran);
    console.log(tran)
  })
//console.log(transdata.data.transactions.transactions)
db.collection('users').doc(userId).collection('transactions').doc().set
})
 })
}
  }


  
}
</script>